import { ActionTypes } from "../Constants/ActionTypes";
import userService from "../../services/user.service";
import { openSuccessPopup } from "./PopupActions";
import { openFailDialog } from "./PopupActions";

export const setBreakdownRequetsData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_BREAKDOWN_REQUESTS_DATA,
    payload: payload,
  });
};

export const updateBreakdownRequestContent = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.UPDATE_BREAKDOWN_CONTENT,
    payload: payload,
  });
};

export const updateBreakdownRequestPage = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.UPDATE_BREAKDOWN_PAGE,
    payload: payload,
  });
};

export const deleteBreakdownrequest = (dispatch, payload) => {
  const { id, breakdownRequestData } = payload;
  userService
    .deleteBreakdownRequest(id)
    .then((response) => {
      const items = breakdownRequestData?.content.filter((ele) => {
        return ele.id != id;
      });
      dispatch({
        type: ActionTypes.UPDATE_BREAKDOWN_CONTENT,
        payload: items,
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      openSuccessPopup(dispatch, {
        successPopUp: {
          message: response.data.message,
          open: true,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      openFailDialog(dispatch, {
        open: true,
        message: "Something Went Wrong",
      });
    });
};

export const deleteCreateHighlightRequest = (dispatch, payload) => {
  const { id, apiCall, shareMediaId } = payload;
  userService
    .deleteHighlight(id)
    .then((response) => {
      userService.sendApproveRequest(shareMediaId, false, id).then((res) => {
        apiCall();
        dispatch({
          type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
          payload: false,
        });
        openSuccessPopup(dispatch, {
          successPopUp: {
            message: "Deleted Successfully",
            open: true,
          },
        });
      });
    })
    .catch((error) => {
      openFailDialog(dispatch, {
        open: true,
        message: "Something Went Wrong",
      });
    });
};

export const approveBreakdownRequest = (dispatch, payload) => {
  const { id, breakdownRequestData } = payload;
  userService
    .approveBreakdownRequest(id)
    .then((response) => {
      const items = breakdownRequestData?.content.filter((ele) => {
        return ele.id != id;
      });
      items.push(response.data.data);
      dispatch({
        type: ActionTypes.UPDATE_BREAKDOWN_CONTENT,
        payload: items,
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      openSuccessPopup(dispatch, {
        successPopUp: {
          message: response.data.message,
          open: true,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      openFailDialog(dispatch, {
        open: true,
        message: "Something Went Wrong",
      });
    });
};

export const disApproveBreakdownRequest = (dispatch, payload) => {
  const { id, breakdownRequestData } = payload;
  userService
    .disApproveBreakdownRequest(id)
    .then((response) => {
      const items = breakdownRequestData?.content.filter((ele) => {
        return ele.id != id;
      });
      items.push(response.data.data);
      dispatch({
        type: ActionTypes.UPDATE_BREAKDOWN_CONTENT,
        payload: items,
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      openSuccessPopup(dispatch, {
        successPopUp: {
          message: response.data.message,
          open: true,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      openFailDialog(dispatch, {
        open: true,
        message: "Something Went Wrong",
      });
    });
};
